import React,{useState} from 'react'
import { useHistory } from 'react-router-dom'
import {DivMain,Button} from './stylePaymentSuccess'
import {DivButtonAcessar} from '../index/style';
import Login from '../login/Login';
export default function PaymentSuccess() {
    const history = useHistory();

    const check = require('../../assets/svgs/check.svg').default;
    const logo = require('../../assets/images/logo_200_social.jpg').default;
    const [objLogin,setObjLogin] = useState({});



    return(
        <DivMain>
            <img src={ logo } />
            <img style={{width:'200px',margin:'0 0 30px 0'}} src={check} />
            <h2 style={{margin:'0 0 15px 0'}}>Pagamento realizado com sucesso!</h2>
            <DivButtonAcessar>
                <Login login={objLogin} txtbutton='Clique aqui para voltar ao sistema' />
            </DivButtonAcessar>
        </DivMain>
    )
}
